import React from "react";
import useModal from "../../../hooks/useModal";
import { useClientFileStore } from "../../../stores/admin/clientFile";
import pen from "../../../assets/icons/edit.svg";
import UpdateClientFile from "../Modales/UpdateClientFile";

const ClientFilesAdminTable = () => {
  // Store
  const { clientFiles } = useClientFileStore();

  // Hook
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();
 
  return (
    <div className="w-full h-full">
      {isModalOpen ? modalContent : null}
      
      {/* En-têtes de colonnes avec design moderne */}
      <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 sticky top-0">
        <div className="grid grid-cols-4 gap-4 text-sm font-semibold text-gray-700">
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Nom du dossier
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Responsable
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              Missions
            </span>
          </div>
          <div className="col-span-1 flex items-center justify-center">
            <span className="text-center">Actions</span>
          </div>
        </div>
      </div>

      {/* Corps de la table avec design moderne */}
      <div className="w-full overflow-y-auto max-h-[calc(90vh-20rem)]">
        {clientFiles?.length === 0 || clientFiles === undefined ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun dossier client trouvé</h3>
            <p className="text-gray-500">Aucun dossier client n'a été trouvé.</p>
          </div>
        ) : (
          clientFiles?.map((clientfile: any) => (
            <div
              key={clientfile?.id}
              className={`w-full transition-all duration-200 border-b border-gray-100 grid grid-cols-4 gap-4 px-6 py-4 ${
                clientfile?.closed === 1
                  ? "bg-gray-50 text-gray-500"
                  : "hover:bg-blue-50"
              }`}
            >
              {/* Nom du dossier */}
              <div className="col-span-1 flex items-center">
                <div className={`font-medium ${clientfile?.closed === 1 ? 'text-gray-500' : 'text-gray-900'}`}>
                  {clientfile?.name}
                </div>
                {clientfile?.closed === 1 && (
                  <div className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-200 text-gray-600">
                    Archivé
                  </div>
                )}
              </div>
              
              {/* Responsable */}
              <div className="col-span-1 flex items-center">
                <div className={`${clientfile?.closed === 1 ? 'text-gray-500' : 'text-gray-700'}`}>
                  {clientfile?.User?.fullName === " " || clientfile?.User?.fullName === "" 
                    ? clientfile?.User?.eMail 
                    : clientfile?.User?.fullName}
                </div>
              </div>
              
              {/* Nombre de missions */}
              <div className="col-span-1 flex items-center">
                <div className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                  clientfile?.closed === 1 
                    ? 'bg-gray-200 text-gray-600' 
                    : 'bg-blue-100 text-blue-800'
                }`}>
                  {clientfile?.missionCount || 0} mission{clientfile?.missionCount > 1 ? 's' : ''}
                </div>
              </div>
              
              {/* Actions */}
              <div className="col-span-1 flex items-center justify-center gap-2">
                {/* Bouton Modifier */}
                <button
                  type="button"
                  className={`p-2 rounded-lg transition-colors duration-200 cursor-pointer group ${
                    clientfile?.closed === 1
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'bg-blue-100 hover:bg-blue-200'
                  }`}
                  onClick={() => {
                    if (clientfile?.closed !== 1) {
                      openModal(
                        <UpdateClientFile 
                          id={clientfile?.id} 
                          closeModal={closeModal} 
                          name={clientfile?.name} 
                          idManager={clientfile?.User?.id}
                        />
                      );
                    }
                  }}
                  disabled={clientfile?.closed === 1}
                  title={clientfile?.closed === 1 ? "Impossible de modifier un dossier archivé" : "Modifier"}
                >
                  <img 
                    className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                    src={pen} 
                    alt="stylo" 
                  />
                </button>
                
                {/* Bouton Supprimer */}
               {/*  <button
                  className={`p-2 rounded-lg transition-colors duration-200 cursor-pointer group ${
                    clientfile?.closed === 1
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'bg-red-100 hover:bg-red-200'
                  }`}
                  onClick={() => {
                    if (clientfile?.closed !== 1) {
                      openModal(
                        <DeleteClientFile
                          id={clientfile?.id}
                          closeModal={closeModal}
                        />
                      );
                    }
                  }}
                  disabled={clientfile?.closed === 1}
                  title={clientfile?.closed === 1 ? "Impossible de supprimer un dossier archivé" : "Supprimer"}
                >
                  <img 
                    src={trash} 
                    alt="supprimer" 
                    className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                  />
                </button> */}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(ClientFilesAdminTable);
